export default __webpack_public_path__ + "media/images/telephone-33190a37db42f348e44b45b264c41c21.svg";